import { Component } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { NewsPostComponent } from "./news-post.component";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { ActivatedRoute } from "@angular/router";
import { take } from "rxjs";
import { GetNewsPostResponse, GetNewsPostsResponse, NewsPost } from "@apiserver-rest/ponder-data-client-base";

@Component({
    imports: [LoadingComponent, NewsPostComponent],
    templateUrl: "./news.component.html"
})
export class NewsComponent {
    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;

    public posts: NewsPost[] = [];
    public total: number = 0;
    public start: number = 0;
    public end: number = 0;
    public count: number = 0;

    private params!: GetNewsPostsQueryParams;
    public singlePost: boolean = false;

    public constructor(private events: EventBroker, private ponderDataClient: PonderDataClient, private route: ActivatedRoute) {

    }

    public ngOnDestroy(): void {
        
    }

    public ngOnInit(): void {
        this.events.ui.hideNavbarEvent.emit();
        
        this.setQueryParams();

        if (!this.params.id) {
            this.loadMultiPosts();
        } else {
            this.loadSinglePost();
        }        
    }

    private loadMultiPosts(): void
    {
        this.ponderDataClient
            .newsPosts(this.params.start, this.params.limit, true)
            .pipe(take(1))
            .subscribe({
                next: (response: GetNewsPostsResponse) => {
                    if (response.success) {
                        this.posts = response.posts ?? [];
                        this.total = response.total ?? 0;
                        this.start = response.start ?? 0;
                        this.count = response.count ?? 0;
                        this.end = this.start + this.count;
                        this.loadingSuccess = true;

                        this.posts.forEach(p => {
                            if (p.modifiedAt) {
                                if (p.createdAt.getFullYear() == p.modifiedAt.getFullYear() &&
                                    p.createdAt.getMonth() == p.modifiedAt.getMonth() &&
                                    p.createdAt.getDate() == p.modifiedAt.getDate()) {
                                    p.modifiedAt = undefined;   // Don't show quick edits made the same day
                                }
                            }
                        });
                    }
                },
                error: () => {
                    // ... todo ? ...
                }
            })
            .add(() => this.isLoading = false);
    }

    private loadSinglePost() : void
    {
        this.singlePost = true;
        this.ponderDataClient
            .newsPostGet(this.params.id!)
            .pipe(take(1))
            .subscribe({
                next: (response: GetNewsPostResponse) => {
                    if (response.success && response.post) {
                        this.posts = [response.post];
                        this.total = 1;
                        this.start = 0;
                        this.count = 1;
                        this.end = 1;
                    
                        this.loadingSuccess = true;
                    }
                },
                error: () => {
                    // ... todo ? ...   
                }
            })
            .add(() => this.isLoading = false);
    }

    private setQueryParams(): void {
        const rawQueryParams = this.route.snapshot.queryParamMap;

        this.params = {
            start: rawQueryParams.has("start") ? parseInt(rawQueryParams.get("start")!) : 0,
            limit: rawQueryParams.has("limit") ? parseInt(rawQueryParams.get("limit")!) : 10,
            id: rawQueryParams.has("id") ? rawQueryParams.get("id") : null
        };
    }
}

type GetNewsPostsQueryParams = {
    start: number,
    limit: number,
    id: string | null
};